import { useSelector } from 'react-redux';
import { CompanyPlanLevel, CompanyPlanStatus } from '../enum/CompanyPlanLevelEnum';

const useCanUseAttendanceModule = (storeId: string): { canUseAttendanceModule: boolean } => {
  const { company } = useSelector((state: any) => state.user);
  const isStandardOrPremium = [CompanyPlanLevel.STANDARD, CompanyPlanLevel.PREMIUM].includes(
    company?.planLevel
  );
  const isInGraceOrSuspended = [CompanyPlanStatus.GRACE, CompanyPlanStatus.SUSPENDED].includes(
    company?.planStatus
  );

  return {
    canUseAttendanceModule: isStandardOrPremium && !isInGraceOrSuspended
  };
};

export default useCanUseAttendanceModule;
